export const AttendantPermission = {
  canAccessContactHistory: 'canAccessContactHistory',
  canEditContact: 'canEditContact',
};
